module.exports = __webpack_public_path__ + "img/hago.ee9b8cc.jpg";